import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { login } from "../../../api/authApi";

// react-router-dom components
import { Link } from "react-router-dom";

// @mui material components
import Switch from "@mui/material/Switch";

// Soft UI Dashboard React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";

// Authentication layout components
import CoverLayout from "layouts/authentication/components/CoverLayout";
import App_logo from "assets/images/BMAx_orderSystem.png";
import CircularProgress from "@mui/material/CircularProgress";
import { Box } from "@mui/material";
import { notify, notifyCenter } from "utils/toast";


function LogIn() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(true);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const handleSetRememberMe = () => setRememberMe(!rememberMe);
  
  const handleSignIn = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    const data = {
      action: "login",
      username: email,
      password: password,
    };

    try {
      const user = await login(data);
      
      if (!user?.status) {
        throw new Error(user?.message || "Ugyldig legitimasjon. Prøv på nytt.");
      }

      notifyCenter("success", "Brukerpålogging vellykket", { duration: 2000 });
      navigate("/dashboard");
      window.location.reload();
    } catch (err) {
      notifyCenter("error", err.message || "Ugyldig legitimasjon. Prøv på nytt.", { duration: 4000 });
    } finally {
      setIsLoading(false); // Hide the loader after login completes
    }
  };

  return (
    <CoverLayout id="login-cover-layout"  
      header={
        <SoftBox
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            mb: 3,
          }}
        >
          <SoftBox component={Link} to="/" sx={{ maxWidth: 300, width: "100%" }}>
            <img src={App_logo} alt="App Logo" style={{ width: "100%", height: "auto", display: "block" }} />
          </SoftBox>
        </SoftBox>
      }
    >
    {isLoading && (
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 1000,
        }}
      >
        <CircularProgress size={60} color="info" />
      </Box>
    )}
      <SoftBox component="form" role="form" onSubmit={handleSignIn}>
        <SoftBox mb={3}>
         
          <SoftInput 
            type="text"
            placeholder="Skriv inn e-posten din"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </SoftBox>
        <SoftBox mb={3}>
          
          <SoftInput
            type="password"
            placeholder="Skriv inn passordet ditt" 
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </SoftBox>
        <SoftBox display="flex" alignItems="center">
          <Switch checked={rememberMe} onChange={handleSetRememberMe} />
          <SoftTypography
            variant="button"
            fontWeight="regular"
            onClick={handleSetRememberMe}
            sx={{ cursor: "pointer", userSelect: "none" }}
          >
            &nbsp;&nbsp;Husk meg
          </SoftTypography>
        </SoftBox>
        <SoftBox mt={3} mb={1}>
          <SoftButton variant="gradient" color="info" fullWidth type="submit">
            Logg inn
          </SoftButton>
        </SoftBox>
        <SoftBox mt={2} textAlign="center">
          <SoftTypography
            component={Link}
            to="/authentication/forgot-password"
            variant="button"
            color="info"
            fontWeight="medium"
            textGradient
          >
            Glemt passord?
          </SoftTypography>
        </SoftBox>
        <SoftBox mt={1} textAlign="center">
          <SoftTypography variant="button" color="text" fontWeight="regular">
            Har du ikke en konto?{" "}
            <SoftTypography
              component={Link}
              to="javascript:;"
              variant="button"
              color="info"
              fontWeight="medium"
              textGradient
            >
              Registrer deg
            </SoftTypography>
          </SoftTypography>
        </SoftBox>
      </SoftBox>
    </CoverLayout>
  );
}

export default LogIn;
